import { Controller } from "react-hook-form";
import { OperatorType } from "~/pages/security-model/RiskFactorsConfiguration/ConditionBuilder/types";
import { useRiskFactorsConditionTagOperator } from "~/pages/security-model/RiskFactorsConfiguration/ConditionBuilder/ConditionTagOperator/hooks/useRiskFactorsConditionTagOperator";
import { RiskFactorsConditionTagOperatorDropdown } from "~/pages/security-model/RiskFactorsConfiguration/ConditionBuilder/ConditionTagOperator/ConditionTagOperatorDropdown/RiskFactorsConditionTagOperatorDropdown";

type Props = {
  fieldId: string;
  selectionIndex: number;
  conditionIndex: number;
  isReadonly: boolean;
  type?: OperatorType;
};

export const RiskFactorsConditionTagOperator = ({
  fieldId,
  isReadonly,
  conditionIndex,
  selectionIndex,
  type: typeFromProps,
}: Props) => {
  const { name, defaultValue, control, type } =
    useRiskFactorsConditionTagOperator({
      fieldId,
      selectionIndex,
      conditionIndex,
      type: typeFromProps,
    });

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <RiskFactorsConditionTagOperatorDropdown
          type={typeFromProps || type}
          isReadonly={isReadonly}
          defaultValue={defaultValue}
          {...field}
        />
      )}
    />
  );
};
